import { useEffect, useRef } from "react";
import { ChevronDown, ArrowRight } from "lucide-react";
import { EVENT } from "../config";
import Countdown from "./Countdown";

export default function Hero() {
  const innerRef = useRef(null);

  useEffect(() => {
    function onScroll() {
      const el = innerRef.current;
      if (!el) return;
      const y = window.scrollY;
      if (y < 1000) {
        el.style.transform = `translateY(${y * 0.3}px)`;
        el.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.8));
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 pb-20"
    >
      {/* Background photo */}
      <div className="absolute inset-0 z-0 pointer-events-none select-none">
        <img
          src="/heroimage.jpeg"
          alt=""
          className="w-full h-full object-cover object-top opacity-30 grayscale"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/60 via-[#050505]/40 to-[#050505]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/50 via-transparent to-[#050505]/50" />
        <div
          className="absolute inset-0 opacity-20 mix-blend-overlay"
          style={{
            background:
              "radial-gradient(ellipse at 50% 40%, rgba(201, 237, 0, 0.3) 0%, transparent 70%)",
          }}
        />
      </div>

      <div className="container mx-auto px-6 relative z-20 text-center" ref={innerRef}>
        <div className="max-w-4xl mx-auto" id="main-content">
          {/* Badge */}
          <div className="reveal mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C9ED00]/10 border border-[#C9ED00]/20 rounded-full text-[10px] font-bold text-amber-400 tracking-[0.2em] uppercase backdrop-blur-md">
              <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse-dot" />
              Tickets On Sale Now
            </div>
          </div>

          {/* Presenter */}
          <div className="reveal" style={{ transitionDelay: "100ms" }}>
            <p className="text-xs md:text-sm text-white/70 uppercase tracking-[0.3em] mb-6">
              {EVENT.presentedBy} Presents
            </p>
          </div>

          {/* Title */}
          <div className="reveal" style={{ transitionDelay: "200ms" }}>
            <h1 className="text-7xl md:text-9xl font-serif leading-[0.85] tracking-tight mb-8 drop-shadow-2xl">
              <span className="text-[#C9ED00]">RAM</span>
              <br />
              <span className="text-white">MIRIYALA</span>
            </h1>
          </div>

          {/* Subtitle */}
          <div className="reveal" style={{ transitionDelay: "300ms" }}>
            <p className="text-lg md:text-xl text-white/80 max-w-lg mx-auto mb-12 font-medium leading-relaxed">
              Ram Miriyala live with a full band. Telugu folk, Tollywood hits, one night in Raleigh.
            </p>
          </div>

          {/* CTAs — above countdown on mobile so it's above the fold */}
          <div className="reveal flex flex-col items-center justify-center gap-3 mb-10" style={{ transitionDelay: "400ms" }}>
            <a href="#tickets" className="group relative inline-flex items-center justify-center px-10 py-5 bg-amber-500 text-black rounded-full font-bold text-base transition-all duration-300 hover:bg-amber-400 hover:scale-105 overflow-hidden shadow-[0_0_40px_rgba(201,237,0,0.25)] cursor-pointer">
              <span className="relative z-10 flex items-center gap-2">
                Get Tickets Now
                <ArrowRight className="w-4 h-4" />
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </a>
            <a
              href="/ram-raleigh-deal"
              className="inline-flex items-center justify-center px-8 py-3 border border-[#C9ED00]/40 text-[#C9ED00] rounded-full font-bold text-sm transition-all duration-300 hover:bg-[#C9ED00]/10 hover:border-[#C9ED00]/70 hover:scale-105"
            >
              Get $5 Discount
            </a>
          </div>

          {/* Countdown — below CTA, still visible as urgency signal */}
          <div className="reveal mb-6" style={{ transitionDelay: "500ms" }}>
            <Countdown />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-40">
        <ChevronDown className="w-6 h-6 text-white" />
      </div>
    </section>
  );
}
